var amdi18n={"__root":{"java_not_detected":"A <a href='https://www.java.com' target='_blank'>Java</a> installation couldn't be detected, is <a href='https://www.java.com' target='_blank'>Java</a> still installed?","install_and_start":"Please install Java and start the Open eCard App afterwards","yes":"Yes","no":"No","start_client":"Start Open eCard App"},"__de":{"java_not_detected":"Eine <a href='https://www.java.com' target='_blank'>Java</a>-Installation konnte nicht erkannt werden, ist <a href='https://www.java.com' target='_blank'>Java</a> dennoch bereits installiert?","install_and_start":"Bitte installieren Sie Java und starten Sie anschließend die Open eCard App","yes":"Ja","no":"Nein","start_client":"Open eCard App starten"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/nls/WebstartRecoveryStrategyView_strings.js
// module id = 315
// module chunks = 1